"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTitleFulfillmentButtonLayout = exports.getApiFulfillmentButtonLayout = exports.getFulfillmentButtonLayout = void 0;
var meCountryCodes_json_1 = __importDefault(require("lightning-common/lib/configuration/meCountryCodes.json"));
var getFormatForLayout = function (media) {
    if (media.isFormatLockedIn &&
        media.otherFormats &&
        media.otherFormats.length > 0) {
        return media.otherFormats[0].id;
    }
    else if (media.hasNonKindleNonReadFormat &&
        media.nonKindleNonReadFormats != undefined &&
        media.nonKindleNonReadFormats.length > 0) {
        return media.nonKindleNonReadFormats[0].id;
    }
    else if (media.formats != undefined && media.formats.length > 0) {
        return media.formats[0].id;
    }
    return undefined;
};
var setMainButtonFormat = function (buttonLayout, media, featureManager) {
    if (featureManager.isEnabled('sunset-audiobook-rewrite')) {
        if (buttonLayout.mainButton == 'other' ||
            buttonLayout.mainButton == 'unsupported' ||
            buttonLayout.mainButton == 'download' ||
            buttonLayout.mainButton == 'audiobook' ||
            buttonLayout.showOtherButtonBelowDivider ||
            buttonLayout.subButton == 'audiobook') {
            buttonLayout.formatID = getFormatForLayout(media);
        }
    }
    else if (buttonLayout.mainButton == 'other' ||
        buttonLayout.mainButton == 'unsupported' ||
        buttonLayout.showOtherButtonBelowDivider ||
        buttonLayout.subButton == 'audiobook') {
        buttonLayout.formatID = getFormatForLayout(media);
    }
    return buttonLayout;
};
var setAudiobookMainButtonLayout = function (currentLayout, showODFormatButton, isAudiobookAfterSunset) {
    if (showODFormatButton) {
        currentLayout.mainButton = 'odread';
    }
    else if (isAudiobookAfterSunset) {
        currentLayout.mainButton = 'audiobook';
    }
    else {
        currentLayout.mainButton = 'download';
    }
    return currentLayout;
};
var setAudiobookSubButtonLayout = function (currentLayout, media, isAudiobookAfterSunset, showDivider) {
    if (isAudiobookAfterSunset && currentLayout.mainButton != 'audiobook') {
        return ['audiobook', true, false];
    }
    else if (media.isAudiobook &&
        media.isFormatLockedIn &&
        currentLayout.mainButton != 'audiobook' &&
        currentLayout.mainButton != 'download' &&
        media.hasMp3Format) {
        return [
            isAudiobookAfterSunset ? 'audiobook' : 'download',
            true,
            isAudiobookAfterSunset ? false : true,
        ];
    }
    else {
        return [undefined, showDivider, false];
    }
};
var getCleanMacWarningDisplay = function (preCleanLayout, media, featureManager) {
    if (media.isAudiobook) {
        preCleanLayout.formatID = 'audiobook-mp3';
    }
    if (preCleanLayout.showMacOsAudiobookSuppressionStyle == 'warn' &&
        preCleanLayout.subButton == 'mp3Only') {
        preCleanLayout.mainButton = 'download';
        preCleanLayout.subButton = undefined;
        return setMainButtonFormat(preCleanLayout, media, featureManager);
    }
    else if (preCleanLayout.showMacOsAudiobookSuppressionStyle == undefined ||
        preCleanLayout.showMacOsAudiobookSuppressionStyle == 'warn') {
        return setMainButtonFormat(preCleanLayout, media, featureManager);
    }
    var mainButton;
    if (preCleanLayout.mainButton == 'odread' ||
        preCleanLayout.subButton == 'odread') {
        mainButton = 'odread';
    }
    else if (preCleanLayout.subButton == 'mp3Only' ||
        (media.hasMp3Format && !media.hasOverdriveFormat)) {
        mainButton = 'unsupported';
    }
    var newLayout = {
        mainButton: mainButton,
        mainDropdownListItems: [],
        showDivider: false,
        showDownloadDropdownBelowDivider: false,
        showMacOsAudiobookSuppressionStyle: preCleanLayout.showMacOsAudiobookSuppressionStyle,
        showNoKindleWarning: false,
        showOtherButtonBelowDivider: false,
        subButton: undefined,
        subDropdownListItems: undefined,
        suppressAudiobookButton: media.suppressAudiobookDownloadButton,
    };
    if (media.isAudiobook) {
        newLayout.formatID = 'audiobook-mp3';
    }
    return setMainButtonFormat(newLayout, media, featureManager);
};
var getCleanNonDownloadFormats = function (layout, media) {
    if (layout.mainButton === 'download' && !media.hasMediaDoFormat) {
        layout.mainButton = 'unsupported';
    }
    if (layout.subButton === 'audiobook') {
        layout.subButton = undefined;
    }
    if (layout.showOtherButtonBelowDivider ||
        layout.showDownloadDropdownBelowDivider) {
        layout.showOtherButtonBelowDivider = false;
        layout.showDownloadDropdownBelowDivider = false;
        layout.showPdfEpubDownloadMessage = true;
    }
    return layout;
};
var getFulfillmentMainButtonLayout = function (featureManager, media, omc, isAudiobookAfterSunset) {
    var layout = {
        mainButton: undefined,
        mainDropdownListItems: [],
        showNoKindleWarning: false,
    };
    if (media.isFormatLockedIn) {
        if (media.otherFormats == null) {
            return layout;
        }
        if (media.hasKindleFormat && media.isLockedOnKindle) {
            layout.mainButton = 'kindle';
        }
        else if (featureManager.isEnabled('sunset-audiobook-rewrite') &&
            media.isAudiobook) {
            return setAudiobookMainButtonLayout(layout, media.showODFormatButton, isAudiobookAfterSunset);
        }
        else if (media.isAudiobook &&
            !omc &&
            featureManager.isEnabled('odapp-sunset')) {
            if (media.showODFormatButton) {
                layout.mainButton = 'odread';
            }
        }
        else if (!media.suppressAudiobookDownloadButton &&
            !media.showOnlyOverDriveFormat) {
            layout.mainButton = 'other';
        }
        return layout;
    }
    if (media.isEbook) {
        if (media.hasKindleFormat) {
            layout.mainButton = 'kindle';
        }
        else if (media.showNoKindleMessage) {
            layout.showNoKindleWarning = true;
        }
        else if (media.showODFormatButton &&
            featureManager.isEnabled('odread-fulfillment-first')) {
            layout.mainButton = 'odread';
        }
        else if (media.showNonKindleButtonAboveDivider) {
            layout.mainButton = 'other';
        }
        return layout;
    }
    if (featureManager.isEnabled('sunset-audiobook-rewrite') &&
        media.isAudiobook) {
        return setAudiobookMainButtonLayout(layout, media.showODFormatButton, isAudiobookAfterSunset);
    }
    else if (media.isAudiobook &&
        !omc &&
        featureManager.isEnabled('odapp-sunset')) {
        if (media.showODFormatButton) {
            layout.mainButton = 'odread';
        }
        return layout;
    }
    if (!media.isMagazine && !media.showOnlyOverDriveFormat) {
        if (media.showODFormatButton &&
            featureManager.isEnabled('odread-fulfillment-first')) {
            layout.mainButton = 'odread';
        }
        else if (!!media.otherFormats &&
            media.otherFormats.length === 1 &&
            media.hasNonKindleNonReadFormat &&
            !media.suppressAudiobookDownloadButton) {
            layout.mainButton = 'other';
        }
        else if (!!media.otherFormats && media.otherFormats.length > 1) {
            layout.mainButton = 'download';
            layout.mainDropdownListItems = media.nonKindleNonReadFormats || [];
        }
    }
    return layout;
};
var getApiFulfillmentMainButtonLayout = function (featureManager, media, isAudiobookAfterSunset) {
    var layout = {
        mainButton: undefined,
        mainDropdownListItems: [],
        showNoKindleWarning: false,
    };
    if (media.isFormatLockedIn) {
        // curious why we're missing adobe check here that's in Title Fulfillment?
        if (media.otherFormats != null) {
            if (media.hasKindleFormat && media.isLockedOnKindle) {
                layout.mainButton = 'kindle';
            }
            else if (featureManager.isEnabled('sunset-audiobook-rewrite') &&
                media.isAudiobook) {
                return setAudiobookMainButtonLayout(layout, media.showODFormatButton, isAudiobookAfterSunset);
            }
            else if (media.isAudiobook) {
                if (media.showODFormatButton) {
                    layout.mainButton = 'odread';
                }
            }
            else if (!media.suppressAudiobookDownloadButton &&
                !media.showOnlyOverDriveFormat) {
                layout.mainButton = 'download';
                layout.mainDropdownListItems = media.otherFormats || [];
            }
        }
        return layout;
    }
    if (media.isEbook) {
        if (media.hasKindleFormat) {
            layout.mainButton = 'kindle';
        }
        else if (media.showODFormatButton &&
            featureManager.isEnabled('odread-fulfillment-first')) {
            layout.mainButton = 'odread';
        }
        else if (media.showNonKindleButtonAboveDivider) {
            layout.mainButton = 'download';
        }
        return layout;
    }
    if (featureManager.isEnabled('sunset-audiobook-rewrite') &&
        media.isAudiobook) {
        return setAudiobookMainButtonLayout(layout, media.showODFormatButton, isAudiobookAfterSunset);
    }
    else if (media.isAudiobook && media.hasOverdriveFormat) {
        if (media.showODFormatButton) {
            layout.mainButton = 'odread';
        }
        return layout;
    }
    if (!(media.hasMp3Format && !media.hasOverdriveFormat) &&
        !media.isMagazine &&
        !media.showOnlyOverDriveFormat) {
        if (!!media.otherFormats &&
            media.otherFormats.length === 1 &&
            media.hasNonKindleNonReadFormat &&
            !media.suppressAudiobookDownloadButton) {
            layout.mainButton = 'download';
        }
        else if (!!media.otherFormats && media.otherFormats.length > 1) {
            layout.mainButton = 'download';
            layout.mainDropdownListItems = media.nonKindleNonReadFormats || [];
        }
    }
    return layout;
};
var getTitleFulfillmentMainButtonLayout = function (featureManager, media, isIpad, isAudiobookAfterSunset, inApp, suppressAudiobookButton) {
    var layout = {
        mainButton: undefined,
        mainDropdownListItems: [],
        showMainDropdown: false,
        showNoKindleWarning: false,
    };
    //Format locked in should never happen for Title Fulfillment.
    if (media.isFormatLockedIn &&
        !featureManager.isEnabled('sunset-audiobook-rewrite')) {
        if (media.otherFormats &&
            media.otherFormats[0].id === 'ebook-epub-adobe') {
            layout.mainButton = 'kindle';
        }
        else if (isAudiobookAfterSunset) {
            if (media.showODFormatButton) {
                layout.mainButton = 'odread';
            }
        }
        else if (!featureManager.isEnabled('hide-disabled-formats') ||
            media.hasNonKindleNonReadFormat) {
            layout.mainButton = 'other';
        }
        return layout;
    }
    if (media.isEbook) {
        if (media.hasKindleFormat) {
            layout.mainButton = 'kindle';
        }
        else if (media.showNoKindleMessage) {
            layout.showNoKindleWarning = true;
        }
        else if (media.showODFormatButton &&
            featureManager.isEnabled('odread-fulfillment-first')) {
            layout.mainButton = 'odread';
        }
        else if (media.showNonKindleButtonAboveDivider) {
            layout.mainButton = 'download';
        }
        return layout;
    }
    if (media.isAudiobook) {
        if (isIpad && media.hasMp3Format) {
            // 😬
            if (!!media.otherFormats) {
                media.otherFormats.push({
                    name: 'MP3 audiobook',
                    id: 'audiobook-mp3',
                });
            }
        }
        if (featureManager.isEnabled('sunset-audiobook-rewrite')) {
            return setAudiobookMainButtonLayout(layout, media.showODFormatButton, isAudiobookAfterSunset);
        }
        else if (isAudiobookAfterSunset) {
            if (media.showODFormatButton) {
                layout.mainButton = 'odread';
            }
        }
        else if (media.showODFormatButton &&
            featureManager.isEnabled('odread-fulfillment-first')) {
            layout.mainButton = 'odread';
        }
        else if (!media.showOnlyOverDriveFormat) {
            layout.mainButton = 'download';
        }
        return layout;
    }
    if (!media.isMagazine) {
        if (!!media.otherFormats &&
            (media.otherFormats.length === 1 ||
                (media.otherFormats.length === 1 && inApp)) &&
            !suppressAudiobookButton) {
            layout.mainButton = 'download';
        }
        else if (!!media.otherFormats && media.otherFormats.length > 1) {
            layout.showMainDropdown = true;
            layout.mainDropdownListItems = media.nonKindleNonReadFormats || [];
        }
    }
    return layout;
};
var isTolinoUnsupportedButtonType = function (button) {
    return (button === 'audiobook' || button === 'kindle' || button === 'mp3Only');
};
var isUnsupportedTolinoFormat = function (format) {
    if (format === undefined)
        return true;
    var formatParts = format.split('-');
    return format.indexOf('ebook') > -1 && formatParts.length >= 2
        ? ['kobo', 'media', 'kindle'].includes(formatParts[1])
        : true;
};
var modifyButtonsForTolino = function (media, featureManager, currentLayout) {
    if (currentLayout.showMainDropdown) {
        currentLayout.mainDropdownListItems =
            media.tolinoSupportedDropdownFormats || [];
        currentLayout.showMainDropdown =
            currentLayout.mainDropdownListItems.length > 0;
    }
    if (currentLayout.showDownloadDropdownBelowDivider) {
        currentLayout.subDropdownListItems =
            media.tolinoSupportedDropdownFormats || [];
        currentLayout.showDownloadDropdownBelowDivider =
            currentLayout.subDropdownListItems.length > 0;
    }
    currentLayout.showOtherButtonBelowDivider =
        currentLayout.showOtherButtonBelowDivider
            ? !isUnsupportedTolinoFormat(getFormatForLayout(media))
            : false;
    if (isTolinoUnsupportedButtonType(currentLayout.mainButton) ||
        currentLayout.mainButton === undefined ||
        (currentLayout.mainButton === 'odread' && media.isAudiobook) ||
        ((currentLayout.mainButton === 'other' ||
            currentLayout.mainButton === 'download') &&
            isUnsupportedTolinoFormat(getFormatForLayout(media)))) {
        if (currentLayout.subButton === 'odread') {
            currentLayout.mainButton = 'odread';
            currentLayout.subButton = undefined;
        }
        else if (currentLayout.showOtherButtonBelowDivider) {
            currentLayout.mainButton == 'download';
            currentLayout.subButton = undefined;
            currentLayout.showOtherButtonBelowDivider = false;
        }
        else if (currentLayout.showDownloadDropdownBelowDivider) {
            currentLayout.mainButton = currentLayout.subButton = undefined;
            currentLayout.showDivider = false;
        }
        else {
            currentLayout.mainButton = 'unsupported';
        }
    }
    else if (currentLayout.subButton != undefined &&
        isTolinoUnsupportedButtonType(currentLayout.subButton)) {
        currentLayout.subButton = undefined;
    }
    currentLayout.showDivider =
        currentLayout.showOtherButtonBelowDivider ||
            currentLayout.showDownloadDropdownBelowDivider;
    return currentLayout;
};
/**
 * Generates the layout of the fulfillment buttons for the given media.
 * @param {FeatureManager} featureManager Feature manager
 * @param {Media} media Book metadata
 * @param {*} options Includes additional context information for the media title
 * @returns A map of what fulfillment buttons to display to the user
 */
var getFulfillmentButtonLayout = function (featureManager, media, options) {
    var _a;
    var isAudiobookAfterSunset = !options.omc &&
        media.isAudiobook &&
        (featureManager.isEnabled('disableOdAppAccess') ||
            featureManager.isEnabled('promoteLibby'));
    var mainButtonLayout = getFulfillmentMainButtonLayout(featureManager, media, options.omc, isAudiobookAfterSunset);
    var subButton;
    var showDivider = media.showDivider;
    var showOtherButtonBelowDivider = false;
    if (featureManager.isEnabled('sunset-audiobook-rewrite')) {
        if (media.showODFormatButton &&
            mainButtonLayout.mainButton != 'odread') {
            subButton = 'odread';
        }
        else if (media.isAudiobook) {
            _a = setAudiobookSubButtonLayout(mainButtonLayout, media, isAudiobookAfterSunset, showDivider), subButton = _a[0], showDivider = _a[1], showOtherButtonBelowDivider = _a[2];
        }
    }
    else {
        if (media.isAudiobook &&
            !options.omc &&
            featureManager.isEnabled('odapp-sunset')) {
            subButton = 'audiobook';
        }
        else if (media.showODFormatButton &&
            mainButtonLayout.mainButton != 'odread') {
            subButton = 'odread';
        }
    }
    var showDownloadDropdownBelowDivider = false;
    var subDropdownListItems = [];
    if (media.showNonKindleButtonBelowDivider && subButton != 'audiobook') {
        showOtherButtonBelowDivider = true;
    }
    else if (media.showDownloadDropdown) {
        showDownloadDropdownBelowDivider = true;
        subDropdownListItems = media.nonKindleNonReadFormats || [];
    }
    if (options.isTolinoDevice) {
        var newLayout = modifyButtonsForTolino(media, featureManager, {
            mainButton: mainButtonLayout.mainButton,
            showMainDropdown: mainButtonLayout.showMainDropdown,
            mainDropdownListItems: mainButtonLayout.mainDropdownListItems,
            showDivider: showDivider,
            showDownloadDropdownBelowDivider: showDownloadDropdownBelowDivider,
            showOtherButtonBelowDivider: showOtherButtonBelowDivider,
            subButton: subButton,
            subDropdownListItems: subDropdownListItems,
        });
        mainButtonLayout.mainButton = newLayout.mainButton;
        subButton = newLayout.subButton;
        showDivider = newLayout.showDivider;
        showDownloadDropdownBelowDivider =
            newLayout.showDownloadDropdownBelowDivider;
        subDropdownListItems = newLayout.subDropdownListItems || [];
        showOtherButtonBelowDivider = newLayout.showOtherButtonBelowDivider;
        mainButtonLayout.mainDropdownListItems =
            newLayout.mainDropdownListItems || [];
        mainButtonLayout.showMainDropdown = newLayout.showMainDropdown;
    }
    var showMacOsAudiobookSuppressionStyle;
    if (media.isMac &&
        media.isAudiobook &&
        featureManager.isEnabled('macOSAudiobookMessaging') &&
        !options.inApp) {
        showMacOsAudiobookSuppressionStyle = !media.isPreCatalinaMac
            ? 'suppress'
            : 'warn';
    }
    var macCleanLayout = getCleanMacWarningDisplay({
        mainButton: mainButtonLayout.mainButton,
        mainDropdownListItems: mainButtonLayout.mainDropdownListItems,
        showDivider: showDivider,
        showDownloadDropdownBelowDivider: showDownloadDropdownBelowDivider,
        showMacOsAudiobookSuppressionStyle: showMacOsAudiobookSuppressionStyle,
        showNoKindleWarning: mainButtonLayout.showNoKindleWarning,
        showOtherButtonBelowDivider: showOtherButtonBelowDivider,
        subButton: subButton,
        subDropdownListItems: subDropdownListItems,
        suppressAudiobookButton: showMacOsAudiobookSuppressionStyle !== undefined,
    }, media, featureManager);
    if (media.isAudiobook &&
        macCleanLayout.mainButton === 'odread' &&
        macCleanLayout.subButton === 'audiobook' &&
        media.hasNonKindleNonReadFormat &&
        !featureManager.isEnabled('promoteLibby')) {
        macCleanLayout.showDivider = false;
        macCleanLayout.showOtherButtonBelowDivider = false;
    }
    var audiobookAndNotInApp = media.isAudiobook &&
        featureManager.isEnabled('mp3-in-app-only') &&
        !options.inApp;
    var showMp3DesktopMessage = featureManager.isEnabled('disableOdAppAccess') &&
        featureManager.isEnabled('show-od-desktop-message');
    if (audiobookAndNotInApp &&
        (showMp3DesktopMessage || macCleanLayout.subButton === undefined)) {
        macCleanLayout.showDivider = false;
        macCleanLayout.showOtherButtonBelowDivider = false;
    }
    if (media.isAudiobook &&
        macCleanLayout.subButton === undefined &&
        !options.inApp) {
        macCleanLayout.showOtherButtonBelowDivider = false;
    }
    macCleanLayout.suppressAudiobookButton =
        media.suppressAudiobookDownloadButton;
    return macCleanLayout;
};
exports.getFulfillmentButtonLayout = getFulfillmentButtonLayout;
var getApiFulfillmentButtonLayout = function (featureManager, media, options) {
    var _a;
    var isAudiobookAfterSunset = !options.inApp &&
        media.isAudiobook &&
        (featureManager.isEnabled('disableOdAppAccess') ||
            featureManager.isEnabled('promoteLibby'));
    var mainButtonLayout = getApiFulfillmentMainButtonLayout(featureManager, media, isAudiobookAfterSunset);
    var subButton;
    var showDivider = media.showDivider;
    var showOtherButtonBelowDivider = false;
    if (featureManager.isEnabled('sunset-audiobook-rewrite')) {
        if (media.showODFormatButton &&
            mainButtonLayout.mainButton != 'odread') {
            subButton = 'odread';
        }
        else if (mainButtonLayout.mainButton == 'audiobook' &&
            options.appName !== 'OverDrive' &&
            !options.inApp) {
            mainButtonLayout.mainButton = undefined;
            subButton = 'mp3Only';
        }
        else if (media.isAudiobook) {
            _a = setAudiobookSubButtonLayout(mainButtonLayout, media, isAudiobookAfterSunset, showDivider), subButton = _a[0], showDivider = _a[1], showOtherButtonBelowDivider = _a[2];
        }
    }
    else {
        if (media.isAudiobook) {
            if (options.countryCode &&
                (meCountryCodes_json_1.default.codes.indexOf(options.countryCode) > -1 ||
                    options.countryCode === 'CN')) {
                subButton = 'download';
            }
            else {
                if (media.hasMp3Format &&
                    !media.hasOverdriveFormat &&
                    options.appName !== 'OverDrive') {
                    subButton = 'mp3Only';
                }
                else if (options.appName !== 'OverDrive' &&
                    options.appName !== 'Sora') {
                    subButton = 'audiobook';
                }
                else if (options.appName !== 'Sora') {
                    subButton = 'download';
                }
            }
        }
        else if (media.showODFormatButton &&
            mainButtonLayout.mainButton != 'odread') {
            subButton = 'odread';
        }
    }
    var showMacOsAudiobookSuppressionStyle;
    if (media.isMac &&
        media.isAudiobook &&
        featureManager.isEnabled('macOSAudiobookMessaging') &&
        !options.inApp) {
        showMacOsAudiobookSuppressionStyle = !media.isPreCatalinaMac
            ? 'suppress'
            : 'warn';
    }
    var showDownloadDropdownBelowDivider = false;
    var subDropdownListItems = [];
    if (media.showNonKindleButtonBelowDivider && subButton != 'audiobook') {
        showOtherButtonBelowDivider = true;
    }
    else if (media.showDownloadDropdown) {
        showDownloadDropdownBelowDivider = true;
        subDropdownListItems = media.nonKindleNonReadFormats || [];
    }
    if (options.isTolinoDevice) {
        var newLayout = modifyButtonsForTolino(media, featureManager, {
            mainButton: mainButtonLayout.mainButton,
            showMainDropdown: mainButtonLayout.showMainDropdown,
            mainDropdownListItems: mainButtonLayout.mainDropdownListItems,
            showDivider: showDivider,
            showDownloadDropdownBelowDivider: showDownloadDropdownBelowDivider,
            showOtherButtonBelowDivider: showOtherButtonBelowDivider,
            subButton: subButton,
            subDropdownListItems: subDropdownListItems,
        });
        mainButtonLayout.mainButton = newLayout.mainButton;
        subButton = newLayout.subButton;
        showDivider = newLayout.showDivider;
        showDownloadDropdownBelowDivider =
            newLayout.showDownloadDropdownBelowDivider;
        subDropdownListItems = newLayout.subDropdownListItems || [];
        showOtherButtonBelowDivider = newLayout.showOtherButtonBelowDivider;
        mainButtonLayout.mainDropdownListItems =
            newLayout.mainDropdownListItems || [];
        mainButtonLayout.showMainDropdown = newLayout.showMainDropdown;
    }
    var macCleanLayout = getCleanMacWarningDisplay({
        mainButton: mainButtonLayout.mainButton,
        mainDropdownListItems: mainButtonLayout.mainDropdownListItems,
        showDivider: showDivider,
        showDownloadDropdownBelowDivider: showDownloadDropdownBelowDivider,
        showMacOsAudiobookSuppressionStyle: showMacOsAudiobookSuppressionStyle,
        showNoKindleWarning: mainButtonLayout.showNoKindleWarning,
        showOtherButtonBelowDivider: showOtherButtonBelowDivider,
        subButton: subButton,
        subDropdownListItems: subDropdownListItems,
        suppressAudiobookButton: showMacOsAudiobookSuppressionStyle !== undefined,
    }, media, featureManager);
    var downloadCleanLayout = getCleanNonDownloadFormats(macCleanLayout, media);
    return downloadCleanLayout;
};
exports.getApiFulfillmentButtonLayout = getApiFulfillmentButtonLayout;
var getTitleFulfillmentButtonLayout = function (featureManager, media, options) {
    var _a;
    var _b;
    var isIpad = featureManager.isEnabled('stop-treating-ipad-like-mac') &&
        options.isIpadUserAgent;
    var ipadWithRestrictedMp3Format = isIpad &&
        !!media.restrictedFormats &&
        media.restrictedFormats.length === 1 &&
        media.restrictedFormats[0].id === 'audiobook-mp3';
    var ipadWithMP3Format = isIpad && media.hasMp3Format;
    var isAudiobookAfterSunset = !options.inApp &&
        media.isAudiobook &&
        (featureManager.isEnabled('disableOdAppAccess') ||
            featureManager.isEnabled('promoteLibby'));
    var mainButtonLayout = getTitleFulfillmentMainButtonLayout(featureManager, media, isIpad, isAudiobookAfterSunset, options.inApp, options.suppressAudiobookButton);
    var showDivider = !options.suppressAudiobookButton &&
        media.showDivider &&
        !options.kindleOnly;
    var subButton;
    var showOtherButtonBelowDivider = false;
    if (featureManager.isEnabled('sunset-audiobook-rewrite')) {
        if (media.showODFormatButton &&
            !options.kindleOnly &&
            !ipadWithMP3Format &&
            !isAudiobookAfterSunset &&
            mainButtonLayout.mainButton != 'odread') {
            subButton = 'odread';
        }
        else if (media.isAudiobook) {
            _a = setAudiobookSubButtonLayout(mainButtonLayout, media, isAudiobookAfterSunset, showDivider), subButton = _a[0], showDivider = _a[1], showOtherButtonBelowDivider = _a[2];
        }
    }
    else {
        if (media.showODFormatButton &&
            !options.kindleOnly &&
            !ipadWithMP3Format &&
            !isAudiobookAfterSunset &&
            mainButtonLayout.mainButton != 'odread') {
            subButton = 'odread';
        }
        else if (isAudiobookAfterSunset) {
            subButton = 'audiobook';
        }
    }
    if (media.showNonKindleButtonBelowDivider && subButton != 'audiobook') {
        showOtherButtonBelowDivider = true;
    }
    var showDownloadDropdownBelowDivider = !media.showNonKindleButtonBelowDivider && media.showDownloadDropdown;
    if (options.isTolinoDevice) {
        var newLayout = modifyButtonsForTolino(media, featureManager, {
            mainButton: mainButtonLayout.mainButton,
            showMainDropdown: mainButtonLayout.showMainDropdown,
            mainDropdownListItems: mainButtonLayout.mainDropdownListItems,
            showDivider: showDivider,
            showDownloadDropdownBelowDivider: showDownloadDropdownBelowDivider,
            showOtherButtonBelowDivider: showOtherButtonBelowDivider,
            subButton: subButton,
        });
        mainButtonLayout.mainButton = newLayout.mainButton;
        subButton = newLayout.subButton;
        showDivider = newLayout.showDivider;
        showDownloadDropdownBelowDivider =
            newLayout.showDownloadDropdownBelowDivider;
        showOtherButtonBelowDivider = newLayout.showOtherButtonBelowDivider;
        mainButtonLayout.mainDropdownListItems =
            newLayout.mainDropdownListItems || [];
        mainButtonLayout.showMainDropdown = newLayout.showMainDropdown;
    }
    var showRestrictedVideoWarning = media.videoIsRestricted;
    var showRestrictedFormatWarning = !ipadWithRestrictedMp3Format &&
        !!media.restrictedFormats &&
        media.restrictedFormats.length > 0 &&
        !media.hasNonKindleNonReadFormat &&
        !media.preferKindle;
    var showMacOsAudiobookSuppressionStyle;
    if (media.isMac &&
        media.isAudiobook &&
        featureManager.isEnabled('macOSAudiobookMessaging') &&
        !options.inApp) {
        showMacOsAudiobookSuppressionStyle = !media.isPreCatalinaMac
            ? 'suppress'
            : 'warn';
    }
    var layout = __assign(__assign({}, getCleanMacWarningDisplay({
        mainButton: mainButtonLayout.mainButton,
        mainDropdownListItems: mainButtonLayout.mainDropdownListItems,
        showDivider: showDivider,
        subButton: subButton,
        showMacOsAudiobookSuppressionStyle: showMacOsAudiobookSuppressionStyle,
        showDownloadDropdownBelowDivider: showDownloadDropdownBelowDivider,
        showNoKindleWarning: mainButtonLayout.showNoKindleWarning,
        showOtherButtonBelowDivider: showOtherButtonBelowDivider,
    }, media, featureManager)), { showMainDropdown: showMacOsAudiobookSuppressionStyle == 'suppress'
            ? false
            : (_b = mainButtonLayout.showMainDropdown) !== null && _b !== void 0 ? _b : false, showRestrictedVideoWarning: showMacOsAudiobookSuppressionStyle == 'suppress'
            ? false
            : showRestrictedVideoWarning, showRestrictedFormatWarning: showMacOsAudiobookSuppressionStyle == 'suppress'
            ? false
            : showRestrictedFormatWarning });
    var audiobookAndNotInApp = media.isAudiobook &&
        featureManager.isEnabled('mp3-in-app-only') &&
        !options.inApp &&
        media.hasNonKindleNonReadFormat;
    var mainButtonIsAudiobook = layout.mainButton === 'odread' && layout.subButton === 'audiobook';
    if (audiobookAndNotInApp &&
        (mainButtonIsAudiobook || layout.subButton === undefined)) {
        layout.showOtherButtonBelowDivider = false;
        layout.showDivider = false;
    }
    if (media.isAudiobook && layout.subButton === undefined && !options.inApp) {
        layout.showOtherButtonBelowDivider = false;
    }
    return layout;
};
exports.getTitleFulfillmentButtonLayout = getTitleFulfillmentButtonLayout;

//# sourceMappingURL=fulfillment-ts.js.map

//# sourceMappingURL=fulfillment-ts.js.map
